const API = {
  // Auth
  
  COMMON_DROPDOWN: `common/`,
  // Main Dasboard
  GET_DASHBOARD_COUNT: `dashboard/get_dashboard_count`,

  ///////Other Project

  LOGIN_HOST:`/account/admin-login`,
  EVENT:`master/event`,
  ROOM:`master/room`,
  FLOOR:`master/floor`,
  APPROVED:`master/approval-persons`,
  BUYER:`store/buyers`,
  CATEGORY:`store/categories`,
  ITEM:`store/items`,
  PURHASE:`store/purchase-bills`,
  SHOP:`store/sales-bills`,
  STOCK_TRANSACTION:`store/stock-transactions`,
  CHALLAN:`store/challans`,
  ROOMFLOOR:`/master/room/list_by_floors`,

  GUEST:`account/user`,
  ROOM_BOOING:`booking/room`,
  ROOM_AVL:`/master/room/available_rooms`,
  KEY_REQUEST:`/booking/room-key-request`,
BULKROOM:`/master/create-rooms`,
CHECKWAPP:`/account/validate-whatsapp`,
CHECKROOM:`/booking/check-room-availability`,
EVENT_REPORT:`/booking/room/export-guest-list`,
STOCK_REPORT:`/store/stock-report`,
CHALLAN_REPORT:`/store/challan-report`,
ITEM_REPORT:`/store/item-report`,
KEY_REPORT:`/booking/room-key-missing-report`,
DASHBOARD: `/booking/dashboard`
};

export default {
  ...API,
};
